import { useQuery } from "@tanstack/react-query";
import { fetchProducts } from "./api/products";

export const useGetNewReleases = () => {
  return useQuery({
    queryKey: ["newReleases"],
    queryFn: () => fetchProducts(),
  });
};
